/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const DAM_INTEGRATIONS_FORM_IDS = {
  damIntegrationsAccessTokenUrl: 'dam-integrations-access-token-url',
  damIntegrationsAdd: 'dam-integrations-add',
  damIntegrationsAuthUrl: 'dam-integrations-auth-url',
  damIntegrationsCancel: 'dam-integrations-cancel',
  damIntegrationsCheckConnection: 'dam-integrations-check-connection',
  damIntegrationsClientId: 'dam-integrations-client-id',
  damIntegrationsClientSecret: 'dam-integrations-secret',
  damIntegrationsCopyUrl: 'dam-integrations-copy-url',
  damIntegrationsDamDomain: 'dam-integrations-dam-domain',
  damIntegrationsEnabled: 'dam-integrations-enable',
  damIntegrationsM2MClientId: 'dam-integrations-m2m-client-id',
  damIntegrationsM2MClientSecret: 'dam-integrations-m2m-client-secret',
  damIntegrationsName: 'dam-integrations-name',
  damIntegrationsScope: 'dam-integrations-scope',
  damIntegrationsType: 'dam-integrations-type',
};

export const DAM_INTEGRATIONS_DATA_IDS = {
  damIntegrationsAccessTokenUrl: 'Form field: Integration access token url',
  damIntegrationsAdd: 'Button: Add DAM integration',
  damIntegrationsAuthUrl: 'Form field: Integration authorization url',
  damIntegrationsCancel: 'Button: Cancel DAM integration',
  damIntegrationsCheckConnection: 'Button: Check c DAM integration',
  damIntegrationsClientId: 'Form field: Integration client id',
  damIntegrationsClientSecret: 'Form field: Integration client secret',
  damIntegrationsCopyUrl: 'Form field: dam-integrations-copy-url',
  damIntegrationsDamDomain: 'Form field: Integration domain',
  damIntegrationsEnabled: 'Form field: Enable integration',
  damIntegrationsM2MClientId: 'Form field: Integration machine client id',
  damIntegrationsM2MClientSecret: 'Form field: Integration machine client secret',
  damIntegrationsName: 'Form field: Integration friendly name',
  damIntegrationsScope: 'Form field: Integration scope',
  damIntegrationsType: 'Form field: Integration type',
};
